import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { reduxForm, Field, getFormValues } from 'redux-form';
import { Button, HorizontalFormControl } from '../../../../common/components';
import displayName from '../../../../helpers/displayName';
import {
  recalculateCommissions,
  reallocateCommissions,
  clearCommissionReallocation,
} from '../../redux/accountActions';

import { toastr } from 'react-redux-toastr';
import { get } from 'lodash';

import { Col, ControlLabel, FormGroup, Modal } from 'react-bootstrap';
import displayCurrency from '../../../../helpers/displayCurrency';
import formatDate from '../../../../helpers/formatDate';
import cx from 'classnames';
import { compose } from 'redux';
import './ReallocationCommissionModal.scss';

//import './styles.scss';

const FORM_NAME = 'ReallocateCommissionForm';

const ReallocateCommissionsModal = ({
  premiums,
  brokerOrganisationId,
  handleReallocateCommissionClose,
  handleSubmit,
  formValues,
  dispatch,
  reset,
  accountCommissions,
  isCommissionRecalculating,
}) => {
  const [premium, setPremium] = useState();
  const [show, setShow] = useState(false);

  const handleReallocationSubmit = (values) => {
    if (!equalCommission()) {
      toastr.error(
        'Commissions reallocation splits must equal ' + normalisedTotal() + '%',
      );
      return false;
    }
    if (dispatch(reallocateCommissions(premium.id, values))) {
      handleReallocateCommissionClose();
      setShow(false);
    }
  };

  useEffect(() => {
    dispatch(clearCommissionReallocation());
  }, []);

  useEffect(
    () => {
      if (premium && equalCommission()) {
        recalculate(formValues);
      }
    },
    [formValues],
  );

  const recalculate = (commissions) => {
    dispatch(recalculateCommissions(premium.id, commissions));
  };

  const equalCommission = () => {
    return normalisedTotal() === totalCommission();
  };

  const normalisedTotal = () => {
    if (premium) {
      return premium.attributes.commissions.reduce((carry, commission) => {
        const commissionRate = get(commission, 'effective_rate', commission.rate) || 0;
        carry += parseFloat(commissionRate) * 100;
        return carry;
      }, 0);
    }
    return 0;
  };

  const totalCommission = () => {
    const commissions = get(formValues, 'meta.commissions', {});
    if (commissions) {
      return Object.keys(commissions).reduce((carry, commissionKey) => {
        const commissionRate = commissions[commissionKey] || 0;
        carry += parseFloat(commissionRate);
        return carry;
      }, 0);
    }
    return 0;
  };

  const handleOpen = () => {
    dispatch(reset());
    setShow(true);
  };
  const handleClose = () => {
    setShow(false);
  };

  const handleSelectPremium = (id) => () => {
    const selectedPremium = premiums.find((policyPremium) => id === policyPremium.id);
    setPremium(selectedPremium);
  };

  const commissions = get(premium, 'attributes.commissions', []);
  const ownerCommission = commissions.find(
    (commission) => commission.commission_type === 'owner',
  );
  const brokerCommission = commissions.find(
    (commission) => commission.commission_type === 'broker',
  );
  const premiumCommissions = [
    {
      commission_type: 'owner',
      organisation_id: ownerCommission ? ownerCommission.organisation_id : 'owner',
      effective_rate: ownerCommission ? ownerCommission.effective_rate : 0,
      rate: ownerCommission ? ownerCommission.rate : 0,
      amount: ownerCommission ? ownerCommission.amount : 0,
    },
    {
      commission_type: 'broker',
      organisation_id: brokerCommission
        ? brokerCommission.organisation_id
        : brokerOrganisationId,
      effective_rate: brokerCommission ? brokerCommission.effective_rate : 0,
      rate: brokerCommission ? brokerCommission.rate : 0,
      amount: brokerCommission ? brokerCommission.amount : 0,
    },
  ];

  return (
    <div>
      <Button
        className="pull-right"
        type="button"
        bsStyle="primary"
        label="Reallocate Commission"
        handleClick={handleOpen}
      />
      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Commission Reallocation</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <div className="commissions-reallocate-container">
            <form onSubmit={handleSubmit(handleReallocationSubmit)}>
              {premiums.map((policyPremium) => {
                return (
                  <FormGroup>
                    <Col sm={9}>
                      <ControlLabel
                        className={cx('premium-title', {
                          'selected-premium': premium && policyPremium.id === premium.id,
                        })}
                      >
                        {displayCurrency(policyPremium.attributes.gross)} |{' '}
                        {policyPremium.attributes.premium_type} | (
                        {formatDate(policyPremium.attributes.created_at)})
                      </ControlLabel>
                    </Col>
                    <Col sm={3}>
                      <Button
                        label={'Select'}
                        bsStyle={'primary'}
                        className={'pull-right'}
                        handleClick={handleSelectPremium(policyPremium.id)}
                      />
                    </Col>
                  </FormGroup>
                );
              })}
              {premium ? (
                <>
                  <FormGroup>
                    <Col sm={5} smOffset={2}>
                      <ControlLabel>Current Allocation</ControlLabel>
                    </Col>
                    <Col sm={5}>
                      <ControlLabel>New Allocation</ControlLabel>
                    </Col>
                  </FormGroup>

                  {premiumCommissions.map((commission, i) => (
                    <FormGroup key={i}>
                      <Col sm={2}>
                        <ControlLabel>
                          {displayName(commission.commission_type)}
                        </ControlLabel>
                      </Col>
                      <Col sm={5}>
                        <HorizontalFormControl
                          disabled
                          inputOnly
                          input={{ value: '' }}
                          percentage
                          placeholder={(
                            get(commission, 'effective_rate', commission.rate) * 100
                          )
                            .toFixed(2)
                            .toString()}
                          monetaryValue={commission.amount.toString()}
                          className="text-right adjustable"
                        />
                      </Col>
                      <Col sm={5}>
                        <Field
                          name={'meta.commissions[' + commission.organisation_id + ']'}
                          percentage
                          inputOnly
                          placholder={(commission.rate * 100).toFixed(2).toString()}
                          monetaryValue={get(
                            accountCommissions,
                            'meta.commissions[' + commission.organisation_id + '].amount',
                            0,
                          ).toString()}
                          component={HorizontalFormControl}
                          isCalc={isCommissionRecalculating}
                          className="text-right adjustable"
                        />
                      </Col>
                    </FormGroup>
                  ))}
                  <FormGroup>
                    <Col sm={2}>
                      <ControlLabel>Total</ControlLabel>
                    </Col>
                    <Col sm={5}>
                      <HorizontalFormControl
                        name="meta.total.original"
                        disabled
                        inputOnly
                        input={{ value: '' }}
                        percentage
                        placeholder={normalisedTotal()
                          .toFixed(2)
                          .toString()}
                        monetaryValue={premium.attributes.commission.toString()}
                        className="text-right adjustable"
                      />
                    </Col>
                    <Col sm={5}>
                      <HorizontalFormControl
                        name="meta.total.new"
                        disabled
                        input={{ value: '' }}
                        inputOnly
                        percentage
                        placeholder={totalCommission()
                          .toFixed(2)
                          .toString()}
                        monetaryValue={premium.attributes.commission.toString()}
                        isCalc={isCommissionRecalculating}
                        className={cx({
                          'total-error': equalCommission(),
                        })}
                      />
                    </Col>
                  </FormGroup>
                </>
              ) : (
                <div className={'select-premium-text'}>
                  Please select a premium from above to continue...
                </div>
              )}

              <Modal.Footer>
                <Button
                  label="Post Commission Adjustment"
                  bsStyle="primary"
                  className="pull-right"
                  type="submit"
                />
              </Modal.Footer>
            </form>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default compose(
  connect((state, props) => {
    return {
      initialValues: props.resource,
      formValues: getFormValues(FORM_NAME)(state),
      accountCommissions: state.account.commissions,
      isCommissionRecalculating: state.account.isCommissionRecalculating,
    };
  }),
  reduxForm({
    form: FORM_NAME,
  }),
)(ReallocateCommissionsModal);
